export default "__VITE_ASSET__dc74df95__"